import { accountBadgeEntityName } from '../../../../backend/features/badges/shared';
import { useBadgingTranslation } from '../../../../ui/hooks';
import { useDataTableUsingUrl } from '@juvare/common-data-table-ui/DataTable/hooks/useDataTable';
import { FiltersBar } from '@juvare/common-data-table-ui/FiltersBar';
import { useAccountFilter } from '@juvare/contact-management/ui/features/accounts';
import { useDefaultAdvancedSearchItems } from '@juvare/contact-management/ui/features/accounts/hooks/useDefaultAdvancedSearchItems';
import { ContactManagementConfigContext } from '@juvare/contact-management/ui/providers';
import { useStorageList } from '@juvare/platform-sdk-react/ui/hooks';
import React from 'react';
import { mapAccountBadgeFilter } from '../utils/mapAccountBadgeFilter';
import { useAccountBadgeFilterConfig } from './useAccountBadgeFilterConfig';
import { useAccountBadgeListColumns } from './useAccountBadgeListColumns';
export function useAccountBadgeTable({ initialFilter, useDataTableParamOverrides, dataTablePropResultOverrides, }) {
    var _a;
    const { t } = useBadgingTranslation();
    const { accountsTableCustomization } = React.useContext(ContactManagementConfigContext);
    const defaultAdvancedSearchItems = useDefaultAdvancedSearchItems();
    const advancedSearchItems = (accountsTableCustomization === null || accountsTableCustomization === void 0 ? void 0 : accountsTableCustomization.onGetAdvancedSearchItems)
        ? accountsTableCustomization.onGetAdvancedSearchItems(defaultAdvancedSearchItems)
        : defaultAdvancedSearchItems;
    const useResolvedAccountFilter = (_a = accountsTableCustomization === null || accountsTableCustomization === void 0 ? void 0 : accountsTableCustomization.overrideUseAccountFilter) !== null && _a !== void 0 ? _a : useAccountFilter;
    const params = Object.assign({ useDataProvider: (request) => {
            const { data: accountFilter } = useResolvedAccountFilter({ advancedSearchItems, filterData: request.filterData });
            const mappedFilters = mapAccountBadgeFilter({ filterData: request.filterData, accountFilter, initialFilter });
            const response = useStorageList(accountBadgeEntityName, {
                filter: mappedFilters,
                orderBy: request.sortColumnKey
                    ? [{ column: request.sortColumnKey, desc: request.sortColumnDesc }]
                    : undefined,
                limit: request.limit,
                offset: request.offset,
            });
            return Object.assign(Object.assign({}, response), { data: response.data
                    ? {
                        rows: response.data.rows,
                        filteredRowCount: response.data.total,
                    }
                    : undefined, reload: () => {
                    void response.mutate();
                }, customBackendResponseData: {
                    storageClientRequest: {
                        filter: mappedFilters,
                        orderBy: request.sortColumnKey
                            ? [{ column: request.sortColumnKey, desc: request.sortColumnDesc }]
                            : undefined,
                    },
                } });
        }, defaultSortColumnKey: 'accountDisplayName', rowSelectionEnabled: true, onRowClick: () => undefined }, useDataTableParamOverrides);
    const { dataTableProps, filtersBarProps, reload, clearActiveRow } = useDataTableUsingUrl(params);
    const defaultColumns = useAccountBadgeListColumns({ refetchAccountBadgeList: () => Promise.resolve().then(reload) });
    const filterConfig = useAccountBadgeFilterConfig(advancedSearchItems, accountsTableCustomization === null || accountsTableCustomization === void 0 ? void 0 : accountsTableCustomization.extendFilters);
    const defaultDataTableProps = Object.assign(Object.assign({}, dataTableProps), { title: t('badges.badgeDetails.accountBadgeTable.title'), columns: defaultColumns, filtersBar: React.createElement(FiltersBar, Object.assign({}, filtersBarProps, { config: filterConfig })) });
    return {
        dataTableProps: Object.assign(Object.assign({}, defaultDataTableProps), dataTablePropResultOverrides === null || dataTablePropResultOverrides === void 0 ? void 0 : dataTablePropResultOverrides({ defaultDataTableProps, reload })),
        reload: () => {
            var _a;
            (_a = dataTableProps.onDeselectAllRows) === null || _a === void 0 ? void 0 : _a.call(dataTableProps);
            reload();
        },
        clearActiveRow,
    };
}
